<template>
  <div class="container-fluid set-new-password-page">
    <div class="row">
      <LayoutLeftAuth />

      <div class="col-md-5">
        <div class="container h-full d-flex align-items-center justify-content-center">
          <div class="row d-flex flex-column text-center align-items-center">
            <img src="../../assets/img/blue-logo.png" class="logo-mobile-auth d-block d-sm-none" />
            <div class="reset-title">Reset your password</div>
            <div class="reset-undertitle">Create a new password for your account</div>
            <form @submit.prevent="send" @keydown="clearError($event)" autocomplete="no" class="new-auth-form">
              <div class="form-row d-flex justify-content-center align-items-center">
                <div class="col-md-12 col-lg-12 mb-16">
                  <div class="material-textfield">
                    <input
                      v-model="user.password"
                      id="password"
                      type="password"
                      name="password"
                      placeholder=" "
                      autofocus
                    />
                    <label>Password</label>
                    <img src="../../assets/img/info-gray.svg" width="20" class="material-append passwordPopup" />
                  </div>
                  <div id="passwordPopup" style="display: none;">
                    <p class="popup-rules-title">Password rules:</p>
                    <span class="password-popup-list">
                      <p>• 8 characters long</p>
                      <p>• 1 uppercase letter</p>
                      <p>• 1 lowercase letter</p>
                      <p>• 1 number</p>
                    </span>
                  </div>
                  <error-field :errors="errors" field="password" class="material-errors" />
                </div>

                <div class="col-md-12 col-lg-12">
                  <div class="material-textfield">
                    <input
                      v-model="user.password_confirmation"
                      id="password_confirmation"
                      name="password_confirmation"
                      type="password"
                      placeholder=" "
                    />
                    <label>Password confirmation</label>
                  </div>

                  <error-field :errors="errors" field="password_confirmation" class="material-errors" />
                </div>
              </div>
              <error-field :errors="errors" field="credentials" class="material-errors" />
              <error-field :errors="errors" field="exception" class="material-errors" />
              <input type="submit" class="btn btn-primary login-button set-btn hover-btn-bg"
                     value="Set new password"
                     :disabled="errors.any()"
              />
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import tippy from 'tippy.js';
import Errors from '../../classes/Errors';
import ErrorField from '../ErrorField';
import LayoutLeftAuth from './components/LayoutLeftAuth';

export default {
  components: {
    ErrorField,
    LayoutLeftAuth,
  },
  data: () => ({
    user: {
      token: null,
      password: '',
      password_confirmation: '',
    },
    errors: new Errors(),
  }),
  mounted() {
    this.user.token = this.$route.params.token;
    tippy('.passwordPopup', {
      placement: 'bottom',
      html: '#passwordPopup',
      theme: 'password',
    });
  },
  methods: {
    ...mapActions(['setNewPassword']),
    send() {
      if (this.user.password !== this.user.password_confirmation) {
        this.errors.record({ password_confirmation: ['Passwords must match.'] });
      } else {
        this.setNewPassword(this.user)
          .then(() => {
            this.$router.push('/set-new-password-success');
          })
          .catch(err => {
            this.errors.record(err.response.data.error);
          });
      }
    },
    clearError(event) {
      this.errors.clear('credentials');
      this.errors.clear('email');
      this.errors.clear('password');
      this.errors.clear('password_confirmation');
      this.errors.clear(event.target.name);
    },
  },
};
</script>
<style scoped>
.login-input {
  background: rgba(239, 239, 239, 0.2);
  border: 1px solid rgba(97, 97, 97, 0.1);
  border-radius: 3px;
  font-size: 16px;
  line-height: 20px;
  color: #616161;
  width: 318px !important;
}
.reset-title {
  font-weight: 500;
  font-size: 40px;
  line-height: 48px;
  text-align: center;
  letter-spacing: -0.72px;
  color: #131c36;
}
.reset-undertitle {
  margin-top: 7px;
  margin-bottom: 45px;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  color: #3e475e;
}
.set-btn {
  margin-top: 48px;
  margin-bottom: 10px;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  width: 318px;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.25);
}
.mb-16 {
  margin-bottom: 16px;
}
.password-popup-list {
  text-align: left;
}
.password-popup-list p {
  margin: 0;
}
.password-popup-list p:last-of-type {
  margin-bottom: 0;
}
.popup-rules-title {
  margin-bottom: 11px;
}
</style>



// WEBPACK FOOTER //
// src/components/auth/SetNewPassword.vue